import { debounce } from '../utils';
import { TextInput } from './TextInput';

export class FilterTextInput extends TextInput {
  private static readonly MIN_LENGHT = 3;

  private readonly _form: JQuery<HTMLFormElement>;
  private readonly _defaultIcon: JQuery<HTMLElement>;
  private readonly _clearIcon: JQuery<HTMLElement>;
  private readonly _input: JQuery<HTMLInputElement>;

  constructor(inputElement: HTMLElement) {
    super(inputElement.closest('.input-group')!);

    this._input = $(inputElement) as JQuery<HTMLInputElement>;
    const inputGroup = this._input.closest('.input-group')!;
    this._form = this._input.closest(
      'form'
    ) as unknown as JQuery<HTMLFormElement>;
    this._defaultIcon = inputGroup.find('i.icon:not([data-clear-icon])');
    this._clearIcon = inputGroup.find('[data-clear-icon]');

    this.init();
    this.setupEventHandlers();
  }

  private init() {
    this.toggleIcons();
  }

  private setupEventHandlers() {
    this._clearIcon.on('click', () => this.handleClearIconClick());

    this.onChange(debounce(() => this.handleChange()));
  }

  private handleClearIconClick() {
    this._input.val('');
    this.handleChange();
  }

  private handleChange() {
    this.toggleIcons();

    if (this.shouldSubmitForm()) {
      this._form.trigger('submit');
    }
  }

  private toggleIcons() {
    const value = this.getValue();

    if (!value || value.length < FilterTextInput.MIN_LENGHT) {
      this.showDefaultIcon();
    } else if (value.length >= FilterTextInput.MIN_LENGHT) {
      this.showClearIcon();
    }
  }

  private shouldSubmitForm() {
    const value = this.getValue();
    if (!value) {
      return true;
    }

    if (value.length === 0) {
      return true;
    }

    if (value.length >= FilterTextInput.MIN_LENGHT) {
      return true;
    }

    return false;
  }

  private showClearIcon() {
    this._defaultIcon.hide();
    this._clearIcon.show();
  }

  private showDefaultIcon() {
    this._defaultIcon.show();
    this._clearIcon.hide();
  }

  private getValue(): string | null | undefined {
    return this._input.val() as string;
  }
}
